(function () {
  'use strict';

  window.MedicomCustom = window.MedicomCustom || {};

  // =============================================================================
  // 背景スクロールロック（他モーダル等からも利用可）
  // =============================================================================
  var scrollLockCount = 0;
  var scrollY = 0;
  var lenis = null;
  var parallaxMM = null;

  function getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }

  function lockScroll() {
    if (scrollLockCount === 0) {
      scrollY = lenis ? lenis.scroll : window.scrollY || document.documentElement.scrollTop;
      var sbw = getScrollbarWidth();
      document.documentElement.style.setProperty('--scrollbar-width', sbw + 'px');
      document.body.classList.add('is-scroll-locked');
      document.body.style.top = '-' + scrollY + 'px';
      if (lenis) {
        lenis.stop();
      }
    }
    scrollLockCount += 1;
  }

  function unlockScroll() {
    if (scrollLockCount <= 0) {
      return;
    }
    scrollLockCount -= 1;
    if (scrollLockCount === 0) {
      document.body.classList.remove('is-scroll-locked');
      document.body.style.top = '';
      document.documentElement.style.setProperty('--scrollbar-width', '0px');
      window.scrollTo(0, scrollY);
      if (lenis) {
        lenis.scrollTo(scrollY, { immediate: true });
        lenis.start();
      }
    }
  }

  // =============================================================================
  // ヘッダーメニュー（ドロワー + オーバーレイ / PC・SP 共通）
  // =============================================================================
  function initHeaderMenu() {
    var header = document.querySelector('.s-header');
    if (!header) {
      return;
    }

    var menuBtn = header.querySelector('.s-header__menu-btn');
    var overlay = document.querySelector('.c-overlay1');
    if (!menuBtn || !overlay) {
      return;
    }

    var drawer = header.querySelector('.s-header__drawer');
    var drawerId = drawer ? drawer.id : 'header-drawer';

    if (drawer && !drawer.id) {
      drawer.id = drawerId;
    }

    menuBtn.setAttribute('aria-controls', drawerId);
    menuBtn.setAttribute('aria-expanded', 'false');

    function setMenuOpen(isOpen) {
      header.classList.toggle('is-menu-open', isOpen);
      overlay.classList.toggle('is-active', isOpen);
      menuBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      menuBtn.setAttribute('aria-label', isOpen ? 'メニューを閉じる' : 'メニューを開く');

      if (drawer) {
        drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      }

      if (isOpen) {
        lockScroll();
      } else {
        unlockScroll();
      }
    }

    function toggleMenu() {
      setMenuOpen(!header.classList.contains('is-menu-open'));
    }

    menuBtn.addEventListener('click', toggleMenu);
    overlay.addEventListener('click', function () {
      if (header.classList.contains('is-menu-open')) {
        setMenuOpen(false);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && header.classList.contains('is-menu-open')) {
        setMenuOpen(false);
      }
    });
  }

  // =============================================================================
  // Original Brand（Splide カルーセル）
  // =============================================================================
  function initOriginalBrandSplide() {
    if (typeof Splide === 'undefined') {
      return;
    }

    var containers = document.querySelectorAll('.s-original-brand__splide');
    if (!containers.length) {
      return;
    }

    containers.forEach(function (container) {
      var section = container.closest('.s-original-brand');
      if (!section || container._splideInstance) {
        return;
      }

      var delay = parseInt(container.getAttribute('data-autoplay-delay'), 10) || 5000;
      var paginationEl = section.querySelector('.s-original-brand__pagination');
      var paginationItems = paginationEl
        ? paginationEl.querySelectorAll('.s-original-brand__pagination-item')
        : [];
      var slideCount = container.querySelectorAll('.splide__slide').length;
      var useLoop = slideCount > 1;
      var prevBtn = section.querySelector('.s-original-brand__nav-btn--prev');
      var nextBtn = section.querySelector('.s-original-brand__nav-btn--next');

      function resetProgressBar(item) {
        if (!item) {
          return;
        }
        var bar = item.querySelector('i');
        if (!bar) {
          return;
        }
        bar.style.width = '0%';
      }

      function setActivePagination(splideInstance) {
        if (!paginationItems.length) {
          return;
        }
        var activeIndex = splideInstance.index;
        paginationItems.forEach(function (item, index) {
          var isActive = index === activeIndex;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          if (!isActive) {
            resetProgressBar(item);
          }
        });
      }

      function updateNavButtons(splideInstance) {
        if (!prevBtn && !nextBtn) {
          return;
        }
        if (useLoop) {
          if (prevBtn) {
            prevBtn.classList.remove('is-disabled');
            prevBtn.removeAttribute('disabled');
          }
          if (nextBtn) {
            nextBtn.classList.remove('is-disabled');
            nextBtn.removeAttribute('disabled');
          }
          return;
        }
        var index = splideInstance.index;
        if (prevBtn) {
          var isPrevDisabled = index <= 0;
          prevBtn.classList.toggle('is-disabled', isPrevDisabled);
          prevBtn.toggleAttribute('disabled', isPrevDisabled);
        }
        if (nextBtn) {
          var isNextDisabled = index >= slideCount - 1;
          nextBtn.classList.toggle('is-disabled', isNextDisabled);
          nextBtn.toggleAttribute('disabled', isNextDisabled);
        }
      }

      if (paginationEl) {
        paginationEl.style.setProperty('--brand-autoplay-ms', delay + 'ms');
        if (slideCount <= 1) {
          paginationEl.style.display = 'none';
        }
      }

      var splide = new Splide(container, {
        type: useLoop ? 'loop' : 'slide',
        perPage: 4,
        perMove: 1,
        gap: '8px',
        speed: 600,
        pagination: false,
        arrows: false,
        autoplay: useLoop,
        interval: delay,
        pauseOnHover: false,
        pauseOnFocus: false,
        resetProgress: false,
        focus: 0,
        flickPower: 200,
        flickMaxPages: 1,
        waitForTransition: true,
        dragMinThreshold: { touch: 10 },
        breakpoints: {
          767: {
            perPage: 1,
            gap: '4px',
            focus: 'center',
            padding: { left: 50, right: 50 },
            flickPower: 100,
          },
        },
      });

      function getAnimationLimit() {
        return window.innerWidth >= 768 ? 4 : 3;
      }

      function startSectionReveal(allCards) {
        var animationLimit = getAnimationLimit();
        allCards.forEach(function (card, idx) {
          if (idx < animationLimit) {
            card.style.opacity = '';
            card.style.transform = '';
            card.classList.add('scroll-trigger');
          } else {
            card.classList.remove('animate--slide-in');
            card.removeAttribute('data-cascade');
            card.style.opacity = '1';
            card.style.transform = 'none';
          }
        });
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            allCards.forEach(function (card, idx) {
              if (idx < animationLimit) {
                card.classList.add('is-visible');
              }
            });
          });
        });
        if (useLoop && splide.Components && splide.Components.Autoplay) {
          splide.Components.Autoplay.play();
        }
      }

      splide.on('mounted', function () {
        setActivePagination(splide);
        updateNavButtons(splide);
        if (useLoop && splide.Components && splide.Components.Autoplay) {
          splide.Components.Autoplay.pause();
        }
      });

      splide.on('moved', function () {
        setActivePagination(splide);
        updateNavButtons(splide);
      });

      splide.on('autoplay:playing', function (progress) {
        if (!paginationItems.length) {
          return;
        }
        var activeItem = paginationItems[splide.index];
        if (!activeItem) {
          return;
        }
        var activeBar = activeItem.querySelector('i');
        if (!activeBar) {
          return;
        }
        var percent = Math.max(0, Math.min(1, progress)) * 100;
        activeBar.style.width = percent + '%';
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          splide.go('<');
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          splide.go('>');
        });
      }

      paginationItems.forEach(function (item) {
        item.addEventListener('click', function () {
          var index = parseInt(item.getAttribute('data-slide-index'), 10);
          if (Number.isNaN(index)) {
            return;
          }
          splide.go(index);
        });
      });

      container.setAttribute('data-lenis-prevent-touch', '');
      splide.mount();

      // Original Brand 専用: セクション到達でアニメーション + autoplay 同時開始
      var originalSlides = container.querySelectorAll('.splide__slide:not(.splide__slide--clone) .s-original-brand__card');
      var cloneCards = container.querySelectorAll('.splide__slide--clone .s-original-brand__card');
      var animationLimit = getAnimationLimit();
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      // クローンは常に表示状態（アニメーション不要）
      cloneCards.forEach(function (card) {
        card.classList.remove('scroll-trigger', 'animate--slide-in');
        card.removeAttribute('data-cascade');
        card.style.opacity = '1';
        card.style.transform = 'none';
      });

      // オリジナルカード: 汎用 initScrollTrigger の対象外にする
      originalSlides.forEach(function (card, idx) {
        card.classList.remove('scroll-trigger');
        if (idx < animationLimit && !prefersReducedMotion.matches) {
          card.style.opacity = '0';
          card.style.transform = 'translateY(30px)';
        }
      });

      if (prefersReducedMotion.matches) {
        originalSlides.forEach(function (card) {
          card.classList.remove('animate--slide-in');
          card.removeAttribute('data-cascade');
          card.style.opacity = '1';
          card.style.transform = 'none';
        });
        if (useLoop && splide.Components && splide.Components.Autoplay) {
          splide.Components.Autoplay.play();
        }
      } else {
        var sectionObserver = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              startSectionReveal(originalSlides);
              obs.unobserve(entry.target);
            }
          });
        }, {
          threshold: 0.5,
        });
        sectionObserver.observe(section);
      }

      container._splideInstance = splide;
    });
  }

  // =============================================================================
  // Recruit Welfare（Splide カルーセル / SP のみ）
  // =============================================================================
  function initRecruitWelfareSplide() {
    if (typeof Splide === 'undefined') {
      return;
    }

    var containers = document.querySelectorAll('.s-recruit-welfare__splide');
    if (!containers.length) {
      return;
    }

    containers.forEach(function (container) {
      var section = container.closest('.s-recruit-welfare');
      if (!section || container._splideInstance) {
        return;
      }

      var paginationEl = section.querySelector('.s-recruit-welfare__pagination');
      var paginationItems = paginationEl
        ? paginationEl.querySelectorAll('.s-recruit-welfare__pagination-item')
        : [];
      var slideCount = container.querySelectorAll('.splide__slide').length;

      function resetProgressBar(item) {
        if (!item) {
          return;
        }
        var bar = item.querySelector('i');
        if (!bar) {
          return;
        }
        bar.style.width = '0%';
      }

      function setActivePagination(splideInstance) {
        if (!paginationItems.length) {
          return;
        }
        var activeIndex = splideInstance.index;
        paginationItems.forEach(function (item, index) {
          var isActive = index === activeIndex;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          if (isActive) {
            var bar = item.querySelector('i');
            if (bar) {
              bar.style.width = '100%';
            }
          } else {
            resetProgressBar(item);
          }
        });
      }

      if (paginationEl) {
        if (slideCount <= 1) {
          paginationEl.style.display = 'none';
        }
      }

      var splide = new Splide(container, {
        mediaQuery: 'min',
        // ループなしで、アクティブスライドを中央表示にする
        type: 'slide',
        perPage: 1,
        perMove: 1,
        fixedWidth: '260px',
        gap: '8px',
        speed: 600,
        pagination: false,
        arrows: false,
        autoplay: false,
        focus: 'center',
        trimSpace: false,
        flickPower: 100,
        flickMaxPages: 1,
        waitForTransition: true,
        dragMinThreshold: { touch: 10 },
        breakpoints: {
          768: {
            destroy: true,
          },
        },
      });

      splide.on('mounted', function () {
        setActivePagination(splide);
      });

      splide.on('moved', function () {
        setActivePagination(splide);
      });

      paginationItems.forEach(function (item) {
        item.addEventListener('click', function () {
          var index = parseInt(item.getAttribute('data-slide-index'), 10);
          if (Number.isNaN(index)) {
            return;
          }
          splide.go(index);
        });
      });

      container.setAttribute('data-lenis-prevent-touch', '');
      splide.mount();
      container._splideInstance = splide;
    });
  }

  // =============================================================================
  // Recruit Gallery（Splide カルーセル）
  // =============================================================================
  function initRecruitGallerySplide() {
    if (typeof Splide === 'undefined') {
      return;
    }

    var containers = document.querySelectorAll('.s-recruit-gallery__splide');
    if (!containers.length) {
      return;
    }

    function updateGalleryNavButtons(splideInstance, prevBtn, nextBtn) {
      if (!prevBtn && !nextBtn) {
        return;
      }

      var arrowsWrap = prevBtn ? prevBtn.closest('.s-recruit-gallery__arrows') : null;
      var endIndex = splideInstance.Components && splideInstance.Components.Controller
        ? splideInstance.Components.Controller.getEnd()
        : 0;
      var needsArrows = endIndex > 0;

      if (arrowsWrap) {
        arrowsWrap.classList.toggle('is-hidden', !needsArrows);
      }

      if (!needsArrows) {
        return;
      }

      var index = splideInstance.index;

      if (prevBtn) {
        var isPrevDisabled = index <= 0;
        prevBtn.classList.toggle('is-disabled', isPrevDisabled);
        prevBtn.toggleAttribute('disabled', isPrevDisabled);
      }

      if (nextBtn) {
        var isNextDisabled = index >= endIndex;
        nextBtn.classList.toggle('is-disabled', isNextDisabled);
        nextBtn.toggleAttribute('disabled', isNextDisabled);
      }
    }

    containers.forEach(function (container) {
      if (container._splideInstance) {
        return;
      }

      var slideCount = container.querySelectorAll('.splide__slide').length;
      if (!slideCount) {
        return;
      }

      var carouselWrap = container.closest('.s-recruit-gallery__carousel-wrap');
      var prevBtn = carouselWrap ? carouselWrap.querySelector('[data-recruit-gallery-prev]') : null;
      var nextBtn = carouselWrap ? carouselWrap.querySelector('[data-recruit-gallery-next]') : null;
      var arrowsWrap = carouselWrap ? carouselWrap.querySelector('.s-recruit-gallery__arrows') : null;

      if (slideCount <= 1 && arrowsWrap) {
        arrowsWrap.classList.add('is-hidden');
      }

      var splide = new Splide(container, {
        mediaQuery: 'min',
        type: 'slide',
        perMove: 1,
        autoWidth: true,
        focus: 'center',
        trimSpace: false,
        gap: '4px',
        padding: { left: '30px', right: '30px' },
        speed: 600,
        pagination: false,
        arrows: false,
        drag: slideCount > 1,
        flickPower: 100,
        flickMaxPages: 1,
        waitForTransition: true,
        dragMinThreshold: { touch: 10 },
        breakpoints: {
          768: {
            focus: 0,
            trimSpace: true,
            padding: 0,
            gap: '8px',
          },
        },
      });

      container._galleryPrevBtn = prevBtn;
      container._galleryNextBtn = nextBtn;

      splide.on('mounted', function () {
        updateGalleryNavButtons(splide, prevBtn, nextBtn);
      });

      splide.on('moved', function () {
        updateGalleryNavButtons(splide, prevBtn, nextBtn);
      });

      splide.on('resize', function () {
        updateGalleryNavButtons(splide, prevBtn, nextBtn);
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          splide.go('<');
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          splide.go('>');
        });
      }

      container.setAttribute('data-lenis-prevent-touch', '');
      splide.mount();
      container._splideInstance = splide;
    });
  }

  // =============================================================================
  // アコーディオン（汎用）
  // [data-accordion] ルート / [data-accordion-trigger] トリガー / [data-accordion-panel] パネル
  // data-accordion-group で同一グループ内の排他制御（1つだけ開く）
  // =============================================================================
  function setAccordionState(item, isOpen) {
    var trigger = item.querySelector('[data-accordion-trigger]');
    var panel = item.querySelector('[data-accordion-panel]');
    if (!trigger || !panel) {
      return;
    }

    item.classList.toggle('is-open', isOpen);
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

    if (lenis) {
      panel.addEventListener(
        'transitionend',
        function (e) {
          if (e.propertyName === 'grid-template-rows') {
            lenis.resize();
          }
        },
        { once: true }
      );
    }
  }

  function compensateScrollDuring(item, mutateFn) {
    var trigger = item.querySelector('[data-accordion-trigger]');
    if (!trigger) {
      mutateFn();
      return;
    }

    var prevTop = trigger.getBoundingClientRect().top;

    mutateFn();

    var start = performance.now();
    function step() {
      var diff = trigger.getBoundingClientRect().top - prevTop;
      if (Math.abs(diff) > 0.5) {
        if (lenis) {
          lenis.scrollTo(lenis.scroll + diff, { immediate: true });
        } else {
          window.scrollBy(0, diff);
        }
      }
      if (performance.now() - start < 500) {
        requestAnimationFrame(step);
      }
    }
    requestAnimationFrame(step);
  }

  function closeAccordionGroup(item, groupName) {
    var siblings = document.querySelectorAll(
      '[data-accordion][data-accordion-group="' + groupName + '"]'
    );

    var closeOthers = function () {
      siblings.forEach(function (otherItem) {
        if (otherItem !== item) {
          setAccordionState(otherItem, false);
        }
      });
    };

    var hasOtherOpen = Array.prototype.some.call(siblings, function (otherItem) {
      return otherItem !== item && otherItem.classList.contains('is-open');
    });

    if (hasOtherOpen) {
      compensateScrollDuring(item, closeOthers);
    } else {
      closeOthers();
    }
  }

  function initAccordion() {
    var items = document.querySelectorAll('[data-accordion]');
    if (!items.length) {
      return;
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-accordion-trigger]');
      if (!trigger || trigger.dataset.accordionBound === 'true') {
        return;
      }

      trigger.dataset.accordionBound = 'true';
      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        var groupName = item.getAttribute('data-accordion-group');

        if (isOpen) {
          setAccordionState(item, false);
          return;
        }

        if (groupName) {
          closeAccordionGroup(item, groupName);
        }

        setAccordionState(item, true);
      });
    });
  }

  // =============================================================================
  // Recruit Job Gallery（Splide カルーセル / アコーディオン内）
  // =============================================================================
  function initRecruitJobGallery() {
    if (typeof Splide === 'undefined') {
      return;
    }

    var containers = document.querySelectorAll('[data-recruit-job-gallery]');
    if (!containers.length) {
      return;
    }

    var accordionDuration = 400;

    function updateNavButtons(splideInstance, prevBtn, nextBtn) {
      if (!prevBtn && !nextBtn) {
        return;
      }

      var arrowsWrap = prevBtn ? prevBtn.closest('.s-recruit-job__gallery-arrows') : null;
      var endIndex = splideInstance.Components && splideInstance.Components.Controller
        ? splideInstance.Components.Controller.getEnd()
        : 0;
      var needsArrows = endIndex > 0;

      if (arrowsWrap) {
        arrowsWrap.classList.toggle('is-hidden', !needsArrows);
      }

      if (!needsArrows) {
        return;
      }

      var index = splideInstance.index;

      if (prevBtn) {
        var isPrevDisabled = index <= 0;
        prevBtn.classList.toggle('is-disabled', isPrevDisabled);
        prevBtn.toggleAttribute('disabled', isPrevDisabled);
      }

      if (nextBtn) {
        var isNextDisabled = index >= endIndex;
        nextBtn.classList.toggle('is-disabled', isNextDisabled);
        nextBtn.toggleAttribute('disabled', isNextDisabled);
      }
    }

    function mountGallerySplide(container) {
      if (container._splideInstance) {
        container._splideInstance.refresh();
        updateNavButtons(
          container._splideInstance,
          container._galleryPrevBtn,
          container._galleryNextBtn
        );
        return;
      }

      var accordionItem = container.closest('[data-accordion]');
      if (!accordionItem || !accordionItem.classList.contains('is-open')) {
        return;
      }

      var prevBtn = container.querySelector('[data-recruit-job-gallery-prev]');
      var nextBtn = container.querySelector('[data-recruit-job-gallery-next]');
      var slideCount = container.querySelectorAll('.splide__slide').length;

      if (slideCount <= 1) {
        var arrowsWrap = container.querySelector('.s-recruit-job__gallery-arrows');
        if (arrowsWrap) {
          arrowsWrap.classList.add('is-hidden');
        }
      }

      var splide = new Splide(container, {
        type: 'slide',
        fixedWidth: '278px',
        perMove: 1,
        gap: '8px',
        speed: 600,
        pagination: false,
        arrows: false,
        drag: true,
        flickPower: 200,
        flickMaxPages: 1,
        waitForTransition: true,
        dragMinThreshold: { touch: 10 },
        breakpoints: {
          767: {
            fixedWidth: '240px',
            padding: { right: '30%' },
            gap: '8px',
          },
        },
      });

      container._galleryPrevBtn = prevBtn;
      container._galleryNextBtn = nextBtn;

      splide.on('mounted', function () {
        updateNavButtons(splide, prevBtn, nextBtn);
        if (lenis) {
          lenis.resize();
        }
      });

      splide.on('moved', function () {
        updateNavButtons(splide, prevBtn, nextBtn);
      });

      splide.on('resize', function () {
        updateNavButtons(splide, prevBtn, nextBtn);
        if (lenis) {
          lenis.resize();
        }
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          splide.go('<');
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          splide.go('>');
        });
      }

      splide.mount();
      container._splideInstance = splide;
    }

    function bindAccordionGallery(container) {
      if (container.dataset.recruitJobGalleryBound === 'true') {
        mountGallerySplide(container);
        return;
      }

      container.dataset.recruitJobGalleryBound = 'true';

      var accordionItem = container.closest('[data-accordion]');
      if (!accordionItem) {
        mountGallerySplide(container);
        return;
      }

      if (accordionItem.classList.contains('is-open')) {
        mountGallerySplide(container);
      }

      var trigger = accordionItem.querySelector('[data-accordion-trigger]');
      if (!trigger) {
        return;
      }

      trigger.addEventListener('click', function () {
        window.setTimeout(function () {
          if (accordionItem.classList.contains('is-open')) {
            mountGallerySplide(container);
          }
        }, accordionDuration);
      });
    }

    containers.forEach(bindAccordionGallery);
  }

  // =============================================================================
  // Hero（Splide フェードスライダー）
  // =============================================================================
  function initHeroSplide() {
    if (typeof Splide === 'undefined') {
      return;
    }

    var containers = document.querySelectorAll('.s-hero__splide');
    if (!containers.length) {
      return;
    }

    containers.forEach(function (container) {
      var section = container.closest('.s-hero');
      if (!section || container._splideInstance) {
        return;
      }

      var delay = parseInt(container.getAttribute('data-autoplay-delay'), 10) || 5000;
      var paginationEl = section.querySelector('.s-hero__pagination');
      var paginationItems = paginationEl
        ? paginationEl.querySelectorAll('.s-hero__pagination-item')
        : [];
      var slideCount = container.querySelectorAll('.splide__slide').length;
      var useLoop = slideCount > 1;
      var bgLayers = section.querySelectorAll('.s-hero__bg-layer');
      var copyrightItems = section.querySelectorAll('.s-hero__copyright-item, .s-hero__copyright-item-sp');
      var prevBtn = section.querySelector('.s-hero__nav-btn--prev');
      var nextBtn = section.querySelector('.s-hero__nav-btn--next');

      function resetProgressBar(item) {
        if (!item) {
          return;
        }
        var bar = item.querySelector('i');
        if (!bar) {
          return;
        }
        bar.style.width = '0%';
      }

      function setActivePagination(splideInstance) {
        if (!paginationItems.length) {
          return;
        }
        var activeIndex = splideInstance.index;
        paginationItems.forEach(function (item, index) {
          var isActive = index === activeIndex;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          if (!isActive) {
            resetProgressBar(item);
          }
        });
      }

      function setActiveBg(splideInstance) {
        if (!bgLayers.length) {
          return;
        }
        var activeIndex = splideInstance.index;
        bgLayers.forEach(function (layer, index) {
          layer.classList.toggle('is-active', index === activeIndex);
        });
      }

      function setActiveCopyright(splideInstance) {
        if (!copyrightItems.length) {
          return;
        }
        var activeIndex = splideInstance.index;
        copyrightItems.forEach(function (item) {
          var itemIndex = parseInt(item.getAttribute('data-slide-index'), 10);
          item.classList.toggle('is-active', itemIndex === activeIndex);
        });
      }

      function updateNavButtons(splideInstance) {
        if (!prevBtn && !nextBtn) {
          return;
        }
        if (useLoop) {
          if (prevBtn) {
            prevBtn.classList.remove('is-disabled');
            prevBtn.removeAttribute('disabled');
          }
          if (nextBtn) {
            nextBtn.classList.remove('is-disabled');
            nextBtn.removeAttribute('disabled');
          }
          return;
        }
        var index = splideInstance.index;
        if (prevBtn) {
          var isPrevDisabled = index <= 0;
          prevBtn.classList.toggle('is-disabled', isPrevDisabled);
          prevBtn.toggleAttribute('disabled', isPrevDisabled);
        }
        if (nextBtn) {
          var isNextDisabled = index >= slideCount - 1;
          nextBtn.classList.toggle('is-disabled', isNextDisabled);
          nextBtn.toggleAttribute('disabled', isNextDisabled);
        }
      }

      if (paginationEl) {
        paginationEl.style.setProperty('--hero-autoplay-ms', delay + 'ms');
        if (!useLoop) {
          paginationEl.style.display = 'none';
          var navEl = section.querySelector('.s-hero__nav');
          if (navEl) {
            navEl.style.display = 'none';
          }
        }
      }

      var splide = new Splide(container, {
        type: 'fade',
        rewind: useLoop,
        speed: 700,
        pagination: false,
        arrows: false,
        autoplay: useLoop,
        interval: delay,
        pauseOnHover: false,
        pauseOnFocus: false,
        resetProgress: false,
        flickPower: 30,
      });

      var slides = container.querySelectorAll('.splide__slide');
      var enterBackFrame = null;
      var directionClearTimer = null;

      function isForward(newIndex, prevIndex) {
        if (newIndex === 0 && prevIndex === slideCount - 1) {
          return true;
        }
        if (newIndex === slideCount - 1 && prevIndex === 0) {
          return false;
        }
        return newIndex > prevIndex;
      }

      function clearSlideDirectionClasses() {
        if (enterBackFrame) {
          cancelAnimationFrame(enterBackFrame);
          enterBackFrame = null;
        }
        if (directionClearTimer) {
          clearTimeout(directionClearTimer);
          directionClearTimer = null;
        }
        slides.forEach(function (slide) {
          slide.classList.remove('is-exiting', 'is-exiting-back', 'is-entering-back', 'is-entering-back-animate');
        });
      }

      function scheduleDirectionClear() {
        if (directionClearTimer) {
          clearTimeout(directionClearTimer);
        }
        directionClearTimer = setTimeout(function () {
          directionClearTimer = null;
          clearSlideDirectionClasses();
        }, 1200);
      }

      function setSlideDirection(newIndex, prevIndex) {
        if (prevIndex === undefined || prevIndex === newIndex) {
          return;
        }
        clearSlideDirectionClasses();
        if (isForward(newIndex, prevIndex)) {
          if (slides[prevIndex]) {
            slides[prevIndex].classList.add('is-exiting');
          }
          return;
        }
        if (!slides[newIndex]) {
          return;
        }
        slides[newIndex].classList.add('is-entering-back');
        if (slides[prevIndex]) {
          slides[prevIndex].classList.add('is-exiting-back');
        }
        var enteringIndex = newIndex;
        enterBackFrame = requestAnimationFrame(function () {
          enterBackFrame = requestAnimationFrame(function () {
            enterBackFrame = null;
            var enteringSlide = slides[enteringIndex];
            if (!enteringSlide) {
              return;
            }
            enteringSlide.classList.remove('is-entering-back');
            enteringSlide.classList.add('is-entering-back-animate');
          });
        });
      }

      splide.on('move', function (newIndex, prevIndex) {
        setSlideDirection(newIndex, prevIndex);
        scheduleDirectionClear();
        setTimeout(function () {
          setActiveBg(splide);
        }, 200);
      });

      splide.on('mounted', function () {
        setActivePagination(splide);
        setActiveBg(splide);
        setActiveCopyright(splide);
        updateNavButtons(splide);
      });

      splide.on('moved', function () {
        setActivePagination(splide);
        setActiveCopyright(splide);
        updateNavButtons(splide);
      });

      splide.on('autoplay:playing', function (progress) {
        if (!paginationItems.length) {
          return;
        }
        var activeItem = paginationItems[splide.index];
        if (!activeItem) {
          return;
        }
        var activeBar = activeItem.querySelector('i');
        if (!activeBar) {
          return;
        }
        var percent = Math.max(0, Math.min(1, progress)) * 100;
        activeBar.style.width = percent + '%';
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          splide.go('<');
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          splide.go('>');
        });
      }

      paginationItems.forEach(function (item) {
        item.addEventListener('click', function () {
          var index = parseInt(item.getAttribute('data-slide-index'), 10);
          if (Number.isNaN(index)) {
            return;
          }
          splide.go(index);
        });
      });

      splide.mount();
      container._splideInstance = splide;
    });
  }

  // =============================================================================
  // Modal Gallery Ticker（Splide + WAAPI マーキー）
  // =============================================================================
  function createModalGalleryTicker() {
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var GAP_PC = 80;
    var GAP_SP = 64;
    var PX_PER_SECOND_PC = 60;
    var PX_PER_SECOND_SP = 60;
    var spMediaQuery = window.matchMedia('(max-width: 767px)');

    function getGap() {
      return spMediaQuery.matches ? GAP_SP : GAP_PC;
    }

    function getPxPerSecond() {
      return spMediaQuery.matches ? PX_PER_SECOND_SP : PX_PER_SECOND_PC;
    }

    function stopAnimation(container) {
      if (container._marqueeAnimation) {
        container._marqueeAnimation.cancel();
        container._marqueeAnimation = null;
      }
    }

    function getCycleWidth(container) {
      var gap = getGap();
      var originalSlides = container.querySelectorAll('.splide__slide:not(.splide__slide--clone)');
      var cycleWidth = 0;

      originalSlides.forEach(function (slide) {
        cycleWidth += slide.getBoundingClientRect().width + gap;
      });

      return cycleWidth;
    }

    function startAnimation(container, splide) {
      if (!splide || prefersReducedMotion.matches) {
        stopAnimation(container);
        return;
      }

      var track = container.querySelector('.splide__list');
      if (!track) {
        return;
      }

      var cycleWidth = getCycleWidth(container);
      if (cycleWidth <= 0) {
        return;
      }

      stopAnimation(container);

      var pxPerSecond = getPxPerSecond();
      var durationMs = (cycleWidth / pxPerSecond) * 1000;
      var baseX = splide.Components.Move.toPosition(0);
      var initialX = baseX;
      var endX = initialX - cycleWidth;

      splide.Components.Move.translate(initialX);
      track.style.transform = 'translateX(' + initialX + 'px)';

      container._marqueeAnimation = track.animate(
        [
          { transform: 'translateX(' + initialX + 'px)' },
          { transform: 'translateX(' + endX + 'px)' },
        ],
        {
          duration: durationMs,
          iterations: Infinity,
          easing: 'linear',
        }
      );
    }

    function setupMarqueeResize(container) {
      if (container._modalGalleryMarqueeResizeObserver || typeof ResizeObserver === 'undefined') {
        return;
      }

      var resizeObserver = new ResizeObserver(function () {
        if (container.offsetWidth === 0 || !container._splideInstance || !container._modalGalleryUseLoop) {
          return;
        }

        container._splideInstance.refresh();
        startAnimation(container, container._splideInstance);
      });

      resizeObserver.observe(container);
      container._modalGalleryMarqueeResizeObserver = resizeObserver;
    }

    function setupResizeWatch(container) {
      if (container._modalGalleryResizeObserver || typeof ResizeObserver === 'undefined') {
        return;
      }

      var resizeObserver = new ResizeObserver(function () {
        if (container.offsetWidth === 0 || container._splideInstance) {
          return;
        }

        initContainer(container);
      });

      resizeObserver.observe(container);
      container._modalGalleryResizeObserver = resizeObserver;
    }

    function initContainer(container) {
      if (container._splideInstance) {
        startAnimation(container, container._splideInstance);
        return;
      }

      var slides = container.querySelectorAll('.splide__slide');
      if (!slides.length) {
        return;
      }

      var containerWidth = container.offsetWidth || container.getBoundingClientRect().width;
      if (containerWidth === 0) {
        setupResizeWatch(container);
        return;
      }

      var useLoop = slides.length > 1;
      var gap = getGap();

      var splide = new Splide(container, {
        type: useLoop ? 'loop' : 'slide',
        autoWidth: true,
        gap: gap + 'px',
        arrows: false,
        pagination: false,
        drag: false,
      });

      splide.mount();
      container._splideInstance = splide;
      container._modalGalleryUseLoop = useLoop;

      if (useLoop) {
        setupMarqueeResize(container);
        startAnimation(container, splide);
      }
    }

    function ensure(container) {
      if (!container || typeof Splide === 'undefined') {
        return;
      }

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          initContainer(container);
        });
      });
    }

    function pause(container) {
      if (!container) {
        return;
      }

      stopAnimation(container);
    }

    function destroy(container) {
      if (!container) {
        return;
      }

      stopAnimation(container);

      if (container._modalGalleryMarqueeResizeObserver) {
        container._modalGalleryMarqueeResizeObserver.disconnect();
        container._modalGalleryMarqueeResizeObserver = null;
      }

      if (container._modalGalleryResizeObserver) {
        container._modalGalleryResizeObserver.disconnect();
        container._modalGalleryResizeObserver = null;
      }

      if (container._splideInstance) {
        container._splideInstance.destroy();
        container._splideInstance = null;
      }

      container._modalGalleryUseLoop = false;
    }

    return {
      ensure: ensure,
      pause: pause,
      destroy: destroy,
    };
  }

  var modalGalleryTicker = createModalGalleryTicker();

  function destroyModalGalleryTickers(section) {
    if (!section) {
      return;
    }

    section.querySelectorAll('.s-original-brand__modal-gallery, .s-original-brand-grid__modal-gallery').forEach(function (container) {
      modalGalleryTicker.destroy(container);
    });
  }

  // =============================================================================
  // Original Brand（モーダル）
  // =============================================================================
  function initOriginalBrandModal() {
    var sections = document.querySelectorAll('.s-original-brand');
    if (!sections.length) {
      return;
    }

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var activeModal = null;
    var lastTrigger = null;

    function applyReducedMotion(section) {
      section.classList.toggle('is-reduced-motion', prefersReducedMotion.matches);
    }

    function getSectionSplide(section) {
      var container = section.querySelector('.s-original-brand__splide');
      return container && container._splideInstance ? container._splideInstance : null;
    }

    function openModal(modal, trigger) {
      if (!modal || activeModal === modal) {
        return;
      }

      if (activeModal) {
        closeModal();
      }

      activeModal = modal;
      lastTrigger = trigger || null;

      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () {
        modal.classList.add('is-active');
        var gallery = modal.querySelector('.s-original-brand__modal-gallery');
        if (gallery) {
          modalGalleryTicker.ensure(gallery);
        }
      });

      lockScroll();

      var closeBtn = modal.querySelector('.s-original-brand__modal-close');
      if (closeBtn) {
        closeBtn.focus();
      }
    }

    function closeModal() {
      if (!activeModal) {
        return;
      }

      var modal = activeModal;
      var section = modal.closest('.s-original-brand');
      var gallery = modal.querySelector('.s-original-brand__modal-gallery');

      if (gallery) {
        modalGalleryTicker.pause(gallery);
      }

      modal.classList.remove('is-active');
      modal.classList.add('is-closing');
      modal.setAttribute('aria-hidden', 'true');
      unlockScroll();
      activeModal = null;

      window.setTimeout(function () {
        modal.classList.remove('is-closing');
        if (!modal.classList.contains('is-active')) {
          modal.setAttribute('hidden', '');
        }
      }, 500);

      if (section) {
        var heading = section.querySelector('.c-dot-title__text');
        if (heading) {
          heading.setAttribute('tabindex', '-1');
          heading.focus({ preventScroll: true });
        }
      }
      lastTrigger = null;
    }

    sections.forEach(function (section) {
      applyReducedMotion(section);

      var cards = section.querySelectorAll('.s-original-brand__card[data-modal-index]');
      var modals = section.querySelectorAll('.s-original-brand__modal');

      cards.forEach(function (card) {
        card.addEventListener('click', function (event) {
          event.preventDefault();
          var index = card.getAttribute('data-modal-index');
          if (!index) {
            return;
          }
          var modal = section.querySelector(
            '.s-original-brand__modal[data-modal-index="' + index + '"]'
          );
          openModal(modal, card);
        });
      });

      modals.forEach(function (modal) {
        var overlay = modal.querySelector('.s-original-brand__modal-overlay');
        var closeBtn = modal.querySelector('.s-original-brand__modal-close');

        if (overlay) {
          overlay.addEventListener('click', closeModal);
        }
        if (closeBtn) {
          closeBtn.addEventListener('click', closeModal);
        }
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && activeModal) {
        closeModal();
      }
    });

    if (typeof prefersReducedMotion.addEventListener === 'function') {
      prefersReducedMotion.addEventListener('change', function () {
        sections.forEach(function (section) {
          applyReducedMotion(section);
        });
        if (activeModal) {
          var gallery = activeModal.querySelector('.s-original-brand__modal-gallery');
          if (gallery) {
            if (prefersReducedMotion.matches) {
              modalGalleryTicker.pause(gallery);
            } else {
              modalGalleryTicker.ensure(gallery);
            }
          }
        }
      });
    }
  }

  // =============================================================================
  // Original Brand Grid（Service page）モーダル
  // =============================================================================
  function initOriginalBrandGridModal() {
    var sections = document.querySelectorAll('.s-original-brand-grid');
    if (!sections.length) {
      return;
    }

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var activeModal = null;
    var lastTrigger = null;

    function applyReducedMotion(section) {
      section.classList.toggle('is-reduced-motion', prefersReducedMotion.matches);
    }

    function openModal(modal, trigger) {
      if (!modal || activeModal === modal) {
        return;
      }

      if (activeModal) {
        closeModal();
      }

      activeModal = modal;
      lastTrigger = trigger || null;

      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () {
        modal.classList.add('is-active');
        var gallery = modal.querySelector('.s-original-brand-grid__modal-gallery');
        if (gallery) {
          modalGalleryTicker.ensure(gallery);
        }
      });

      lockScroll();

      var closeBtn = modal.querySelector('.s-original-brand-grid__modal-close');
      if (closeBtn) {
        closeBtn.focus();
      }
    }

    function closeModal() {
      if (!activeModal) {
        return;
      }

      var modal = activeModal;
      var section = modal.closest('.s-original-brand-grid');
      var gallery = modal.querySelector('.s-original-brand-grid__modal-gallery');

      if (gallery) {
        modalGalleryTicker.pause(gallery);
      }

      modal.classList.remove('is-active');
      modal.classList.add('is-closing');
      modal.setAttribute('aria-hidden', 'true');
      unlockScroll();
      activeModal = null;

      window.setTimeout(function () {
        modal.classList.remove('is-closing');
        if (!modal.classList.contains('is-active')) {
          modal.setAttribute('hidden', '');
        }
      }, 500);

      if (section) {
        var heading = section.querySelector('.c-dot-title__text');
        if (heading) {
          heading.setAttribute('tabindex', '-1');
          heading.focus({ preventScroll: true });
        }
      }
      lastTrigger = null;
    }

    sections.forEach(function (section) {
      applyReducedMotion(section);

      var cards = section.querySelectorAll('.s-original-brand-grid__card[data-modal-index]');
      var modals = section.querySelectorAll('.s-original-brand-grid__modal');

      cards.forEach(function (card) {
        card.addEventListener('click', function (event) {
          event.preventDefault();
          var index = card.getAttribute('data-modal-index');
          if (!index) {
            return;
          }
          var modal = section.querySelector(
            '.s-original-brand-grid__modal[data-modal-index="' + index + '"]'
          );
          openModal(modal, card);
        });
      });

      modals.forEach(function (modal) {
        var overlay = modal.querySelector('.s-original-brand-grid__modal-overlay');
        var closeBtn = modal.querySelector('.s-original-brand-grid__modal-close');

        if (overlay) {
          overlay.addEventListener('click', closeModal);
        }
        if (closeBtn) {
          closeBtn.addEventListener('click', closeModal);
        }
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && activeModal) {
        closeModal();
      }
    });

    if (typeof prefersReducedMotion.addEventListener === 'function') {
      prefersReducedMotion.addEventListener('change', function () {
        sections.forEach(function (section) {
          applyReducedMotion(section);
        });
        if (activeModal) {
          var gallery = activeModal.querySelector('.s-original-brand-grid__modal-gallery');
          if (gallery) {
            if (prefersReducedMotion.matches) {
              modalGalleryTicker.pause(gallery);
            } else {
              modalGalleryTicker.ensure(gallery);
            }
          }
        }
      });
    }
  }

  // =============================================================================
  // Collaborator（Web Animations API マーキー）
  // =============================================================================
  function initCollaboratorSplide() {
    if (typeof Splide === 'undefined') {
      return;
    }

    var sections = document.querySelectorAll('.s-collaborator');
    if (!sections.length) {
      return;
    }

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var COLLABORATOR_GAP = 8;
    var DEFAULT_ANIMATION_SECONDS = 30;

    function applyReducedMotion(section) {
      section.classList.toggle('is-reduced-motion', prefersReducedMotion.matches);
    }

    function calculateScrollSpeed(animationSeconds) {
      var seconds = animationSeconds || DEFAULT_ANIMATION_SECONDS;
      return DEFAULT_ANIMATION_SECONDS / seconds;
    }

    function stopCollaboratorAnimation(container) {
      if (container._marqueeAnimation) {
        container._marqueeAnimation.cancel();
        container._marqueeAnimation = null;
      }
    }

    function getCollaboratorCycleWidth(container) {
      var originalSlides = container.querySelectorAll('.splide__slide:not(.splide__slide--clone)');
      var cycleWidth = 0;

      originalSlides.forEach(function (slide) {
        cycleWidth += slide.getBoundingClientRect().width + COLLABORATOR_GAP;
      });

      return cycleWidth;
    }

    function startCollaboratorAnimation(container, splide, animationSeconds, isReverse) {
      if (!splide || prefersReducedMotion.matches) {
        stopCollaboratorAnimation(container);
        return;
      }

      var track = container.querySelector('.splide__list');
      if (!track) {
        return;
      }

      var cycleWidth = getCollaboratorCycleWidth(container);
      if (cycleWidth <= 0) {
        return;
      }

      stopCollaboratorAnimation(container);

      var firstSlide = container.querySelector('.splide__slide:not(.splide__slide--clone)');
      var slideWidth = firstSlide ? firstSlide.getBoundingClientRect().width + COLLABORATOR_GAP : 0;
      var startOffset = container._collaboratorStartOffset || 0;
      var offsetPx = slideWidth * (startOffset / 100);

      var baseSpeed = calculateScrollSpeed(animationSeconds);
      var pxPerSecond = Math.abs(baseSpeed) * 60;
      var durationMs = (cycleWidth / pxPerSecond) * 1000;

      var baseX = splide.Components.Move.toPosition(0);
      var initialX = baseX - offsetPx;
      var endX = isReverse ? initialX + cycleWidth : initialX - cycleWidth;

      splide.Components.Move.translate(initialX);
      track.style.transform = 'translateX(' + initialX + 'px)';

      container._marqueeAnimation = track.animate(
        [
          { transform: 'translateX(' + initialX + 'px)' },
          { transform: 'translateX(' + endX + 'px)' },
        ],
        {
          duration: durationMs,
          iterations: Infinity,
          easing: 'linear',
        }
      );
    }

    function setupCollaboratorResizeWatch(container, animationSeconds) {
      if (container._collaboratorResizeObserver || typeof ResizeObserver === 'undefined') {
        return;
      }

      var resizeObserver = new ResizeObserver(function () {
        if (container.offsetWidth === 0 || container._splideInstance) {
          return;
        }
        initCollaboratorContainer(container, animationSeconds);
      });

      resizeObserver.observe(container);
      container._collaboratorResizeObserver = resizeObserver;
    }

    function setupCollaboratorMarqueeResize(container) {
      if (container._collaboratorMarqueeResizeObserver || typeof ResizeObserver === 'undefined') {
        return;
      }

      var resizeObserver = new ResizeObserver(function () {
        if (container.offsetWidth === 0 || !container._splideInstance || !container._collaboratorUseLoop) {
          return;
        }

        startCollaboratorAnimation(
          container,
          container._splideInstance,
          container._collaboratorAnimationSeconds,
          container._collaboratorIsReverse
        );
      });

      resizeObserver.observe(container);
      container._collaboratorMarqueeResizeObserver = resizeObserver;
    }

    function initCollaboratorContainer(container, animationSeconds) {
      if (container._splideInstance) {
        return;
      }

      var slides = container.querySelectorAll('.splide__slide');
      if (!slides.length) {
        return;
      }

      var containerWidth = container.offsetWidth || container.getBoundingClientRect().width;
      if (containerWidth === 0) {
        setupCollaboratorResizeWatch(container, animationSeconds);
        return;
      }

      var direction = container.getAttribute('data-scroll-direction') || 'left';
      var isReverse = direction === 'right';
      var useLoop = slides.length > 1;

      var splide = new Splide(container, {
        type: useLoop ? 'loop' : 'slide',
        autoWidth: true,
        gap: COLLABORATOR_GAP + 'px',
        arrows: false,
        pagination: false,
        drag: false,
      });

      splide.mount();
      container._splideInstance = splide;
      container._collaboratorAnimationSeconds = animationSeconds;
      container._collaboratorIsReverse = isReverse;
      container._collaboratorUseLoop = useLoop;

      var startOffset = parseInt(container.getAttribute('data-start-offset'), 10) || 0;
      container._collaboratorStartOffset = startOffset;

      if (useLoop) {
        setupCollaboratorMarqueeResize(container);
        startCollaboratorAnimation(container, splide, animationSeconds, isReverse);
      }
    }

    sections.forEach(function (section) {
      applyReducedMotion(section);

      var inner = section.querySelector('.s-collaborator__inner');
      var animationSeconds = parseInt(inner && inner.getAttribute('data-animation-speed'), 10)
        || DEFAULT_ANIMATION_SECONDS;
      var containers = section.querySelectorAll('.s-collaborator__splide');

      containers.forEach(function (container) {
        initCollaboratorContainer(container, animationSeconds);
      });
    });

    if (typeof prefersReducedMotion.addEventListener === 'function') {
      prefersReducedMotion.addEventListener('change', function () {
        sections.forEach(function (section) {
          applyReducedMotion(section);
          section.querySelectorAll('.s-collaborator__splide').forEach(function (container) {
            if (!container._splideInstance) {
              return;
            }

            if (prefersReducedMotion.matches) {
              stopCollaboratorAnimation(container);
              return;
            }

            if (container._collaboratorUseLoop) {
              startCollaboratorAnimation(
                container,
                container._splideInstance,
                container._collaboratorAnimationSeconds,
                container._collaboratorIsReverse
              );
            }
          });
        });
      });
    }
  }

  // =============================================================================
  // スクロールトリガー アニメーション
  // =============================================================================
  function initScrollTrigger() {
    var triggers = document.querySelectorAll('.scroll-trigger');
    if (!triggers.length) {
      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      triggers.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.2,
    });

    triggers.forEach(function (el) {
      observer.observe(el);
    });
  }

  // =============================================================================
  // Company History タイムラインライン伸長アニメーション（GSAP ScrollTrigger）
  // =============================================================================
  function initCompanyHistoryFallback(timeline, section) {
    var lineObserver = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          timeline.classList.add('is-line-visible');
          obs.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
    });

    lineObserver.observe(section);
  }

  function initCompanyHistory() {
    var timelines = document.querySelectorAll('.s-company-history__timeline');
    if (!timelines.length) {
      return;
    }

    timelines.forEach(function (timeline) {
      var section = timeline.closest('.s-company-history');
      if (!section) {
        return;
      }

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var reducedLine = timeline.querySelector('.s-company-history__line');
        var reducedArrow = timeline.querySelector('.s-company-history__line-arrow');
        var reducedDots = timeline.querySelectorAll('.s-company-history__dot');

        timeline.classList.add('is-line-visible');

        if (typeof gsap !== 'undefined' && reducedLine) {
          gsap.set(reducedLine, { scaleY: 1, transformOrigin: 'top center' });

          if (reducedArrow) {
            gsap.set(reducedArrow, {
              y: reducedLine.offsetHeight,
              opacity: 1,
              xPercent: -50,
            });
          }
        }

        reducedDots.forEach(function (dot) {
          dot.classList.add('is-dot-revealed');
        });
        return;
      }

      if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        initCompanyHistoryFallback(timeline, section);
        return;
      }

      var line = timeline.querySelector('.s-company-history__line');
      var arrow = timeline.querySelector('.s-company-history__line-arrow');
      var dots = timeline.querySelectorAll('.s-company-history__dot');
      if (!line) {
        return;
      }

      gsap.set(line, { scaleY: 0, transformOrigin: 'top center' });
      if (arrow) {
        gsap.set(arrow, { y: 0, opacity: 0, xPercent: -50 });
      }

      var state = { maxProgress: 0 };
      var dotCount = dots.length;

      dots.forEach(function (dot) {
        dot._revealed = false;
      });

      function computeDotThresholds() {
        var lineTop = parseFloat(getComputedStyle(line).top) || 22;
        var lineHeight = line.offsetHeight;

        dots.forEach(function (dot, index) {
          var entry = dot.closest('.s-company-history__entry');
          if (!entry || lineHeight <= 0) {
            dot._threshold = dotCount > 0 ? (index + 1) / dotCount : 1;
            return;
          }

          var dotOffset = parseFloat(getComputedStyle(dot).top) || 11;
          var dotTop = entry.offsetTop + dotOffset;
          dot._threshold = Math.min(1, Math.max(0, (dotTop - lineTop) / lineHeight));
        });
      }

      function updateArrowTip(progress) {
        if (!arrow) {
          return;
        }

        var lineHeight = line.offsetHeight;
        var tipY = lineHeight * progress;

        gsap.set(arrow, {
          y: tipY,
          opacity: progress > 0.01 ? 1 : 0,
          xPercent: -50,
        });
      }

      function updateTimelineProgress(progress) {
        if (progress <= state.maxProgress) {
          return;
        }

        state.maxProgress = progress;
        gsap.set(line, { scaleY: progress });
        updateArrowTip(progress);

        dots.forEach(function (dot) {
          if (!dot._revealed && progress >= dot._threshold) {
            dot._revealed = true;
            dot.classList.add('is-dot-revealed');
          }
        });
      }

      computeDotThresholds();

      ScrollTrigger.create({
        trigger: section,
        start: 'top 80%',
        end: 'bottom 80%',
        invalidateOnRefresh: true,
        onUpdate: function (self) {
          updateTimelineProgress(self.progress);
        },
        onRefresh: function (self) {
          computeDotThresholds();
          updateTimelineProgress(self.progress);
        },
      });
    });
  }

  // =============================================================================
  // パララックス（data-parallax 属性ベース）
  // =============================================================================
  function buildParallaxFromVars(direction, amount) {
    switch (direction) {
      case 'down':
        return { y: -amount };
      case 'left':
        return { x: amount };
      case 'right':
        return { x: -amount };
      default:
        return { y: amount };
    }
  }

  function buildParallaxToVars(direction) {
    if (direction === 'left' || direction === 'right') {
      return { x: 0 };
    }
    return { y: 0 };
  }

  function getParallaxAttr(el, baseName, fallback) {
    var value = el.getAttribute(baseName);
    return value !== null && value !== '' ? value : fallback;
  }

  function getParallaxAmount(el, baseName, fallback) {
    var value = parseInt(el.getAttribute(baseName), 10);
    return Number.isNaN(value) ? fallback : value;
  }

  function getParallaxFloatAttr(el, primaryAttr, fallbackAttr) {
    var raw = el.getAttribute(primaryAttr);
    if ((raw === null || raw === '') && fallbackAttr) {
      raw = el.getAttribute(fallbackAttr);
    }
    if (raw === null || raw === '') return null;
    var val = parseFloat(raw);
    return Number.isNaN(val) ? null : val;
  }

  function createParallaxTween(el, options) {
    var triggerSelector = getParallaxAttr(el, 'data-parallax-trigger', '');
    var trigger = triggerSelector
      ? document.querySelector(triggerSelector)
      : el.parentElement;
    if (!trigger) {
      return;
    }

    var direction = getParallaxAttr(el, options.directionAttr, 'up');
    var amount = getParallaxAmount(el, options.amountAttr, options.defaultAmount);
    var start = getParallaxAttr(el, options.startAttr, 'top bottom');
    var end = getParallaxAttr(el, options.endAttr, 'bottom center');

    var scaleFrom = getParallaxFloatAttr(
      el, options.scaleAttr, options.scaleFallbackAttr
    );
    var scaleTo = getParallaxFloatAttr(
      el, options.scaleToAttr, options.scaleToFallbackAttr
    );
    var opacityFrom = getParallaxFloatAttr(
      el, options.opacityAttr, options.opacityFallbackAttr
    );
    var opacityTo = getParallaxFloatAttr(
      el, options.opacityToAttr, options.opacityToFallbackAttr
    );
    var yTo = getParallaxFloatAttr(
      el, options.amountToAttr, options.amountToFallbackAttr
    );

    var hasPosition;
    if (yTo !== null) {
      hasPosition = amount !== yTo;
    } else {
      hasPosition = amount !== 0;
    }
    var hasScale = scaleFrom !== null;
    var hasOpacity = opacityFrom !== null;

    if (!hasPosition && !hasScale && !hasOpacity) {
      return;
    }

    var fromVars = {};
    var toVars = {};

    if (hasPosition) {
      if (yTo !== null) {
        var axis = direction === 'left' || direction === 'right' ? 'x' : 'y';
        fromVars[axis] = amount;
        toVars[axis] = yTo;
      } else {
        Object.assign(fromVars, buildParallaxFromVars(direction, amount));
        Object.assign(toVars, buildParallaxToVars(direction));
      }
    }

    if (hasScale) {
      fromVars.scale = scaleFrom;
      toVars.scale = scaleTo !== null ? scaleTo : 1;
    }
    if (hasOpacity) {
      fromVars.opacity = opacityFrom;
      toVars.opacity = opacityTo !== null ? opacityTo : 1;
    }

    gsap.fromTo(
      el,
      fromVars,
      Object.assign(toVars, {
        ease: 'none',
        scrollTrigger: {
          trigger: trigger,
          start: start,
          end: end,
          scrub: true,
          invalidateOnRefresh: true,
        },
      })
    );
  }

  function initParallax() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      return;
    }

    var elements = document.querySelectorAll('[data-parallax]');
    if (!elements.length) {
      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    if (parallaxMM) {
      parallaxMM.revert();
    }
    parallaxMM = gsap.matchMedia();

    parallaxMM.add('(min-width: 768px)', function () {
      elements.forEach(function (el) {
        createParallaxTween(el, {
          amountAttr: 'data-parallax-y',
          amountToAttr: 'data-parallax-y-to',
          directionAttr: 'data-parallax-direction',
          startAttr: 'data-parallax-start',
          endAttr: 'data-parallax-end',
          scaleAttr: 'data-parallax-scale',
          scaleToAttr: 'data-parallax-scale-to',
          opacityAttr: 'data-parallax-opacity',
          opacityToAttr: 'data-parallax-opacity-to',
          defaultAmount: 150,
        });
      });
    });

    parallaxMM.add('(max-width: 767px)', function () {
      elements.forEach(function (el) {
        createParallaxTween(el, {
          amountAttr: 'data-parallax-y-sp',
          amountToAttr: 'data-parallax-y-to-sp',
          amountToFallbackAttr: 'data-parallax-y-to',
          directionAttr: 'data-parallax-direction-sp',
          startAttr: 'data-parallax-start-sp',
          endAttr: 'data-parallax-end-sp',
          scaleAttr: 'data-parallax-scale-sp',
          scaleToAttr: 'data-parallax-scale-to-sp',
          opacityAttr: 'data-parallax-opacity-sp',
          opacityToAttr: 'data-parallax-opacity-to-sp',
          scaleFallbackAttr: 'data-parallax-scale',
          scaleToFallbackAttr: 'data-parallax-scale-to',
          opacityFallbackAttr: 'data-parallax-opacity',
          opacityToFallbackAttr: 'data-parallax-opacity-to',
          defaultAmount: getParallaxAmount(el, 'data-parallax-y', 150),
        });
      });
    });
  }

  function initBlogPagination() {
    var pagination = document.querySelector('.s-blog__pagination');
    if (!pagination) {
      return;
    }

    var input = pagination.querySelector('.s-blog__pagination-input');
    if (!input) {
      return;
    }

    var currentPage = parseInt(pagination.dataset.currentPage, 10) || 1;
    var totalPages = parseInt(pagination.dataset.totalPages, 10) || 1;
    var prevBtn = pagination.querySelector('.s-blog__pagination-arrow--prev');
    var nextBtn = pagination.querySelector('.s-blog__pagination-arrow--next');
    var prevUrl = pagination.dataset.prevUrl || '';
    var nextUrl = pagination.dataset.nextUrl || '';

    function navigateToPage(page) {
      var pageNumber = parseInt(page, 10);
      if (!pageNumber || pageNumber < 1 || pageNumber > totalPages || pageNumber === currentPage) {
        return false;
      }

      var url = new URL(window.location.href);
      url.searchParams.set('page', String(pageNumber));
      window.location.href = url.toString();
      return true;
    }

    input.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') {
        return;
      }

      event.preventDefault();
      navigateToPage(input.value);
    });

    input.addEventListener('blur', function () {
      input.value = String(currentPage);
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (prevUrl) {
          window.location.href = prevUrl;
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (nextUrl) {
          window.location.href = nextUrl;
        }
      });
    }
  }

  // =============================================================================
  // ブログ詳細：シェア（リンクコピー）
  // =============================================================================
  function initArticleShare() {
    var copyBtn = document.querySelector('.s-article__share-copy');
    if (!copyBtn) {
      return;
    }

    var copiedLabel = copyBtn.getAttribute('data-copied-label') || 'Copied';

    copyBtn.addEventListener('click', function () {
      var url = copyBtn.getAttribute('data-article-url');
      if (!url) {
        return;
      }

      function onCopied() {
        alert(copiedLabel);
        var originalLabel = copyBtn.getAttribute('aria-label');
        copyBtn.setAttribute('aria-label', copiedLabel);
        copyBtn.classList.add('is-copied');

        window.setTimeout(function () {
          copyBtn.setAttribute('aria-label', originalLabel);
          copyBtn.classList.remove('is-copied');
        }, 2000);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(onCopied).catch(function () {
          window.prompt('', url);
        });
        return;
      }

      var textarea = document.createElement('textarea');
      textarea.value = url;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        document.execCommand('copy');
        onCopied();
      } catch (error) {
        window.prompt('', url);
      }

      document.body.removeChild(textarea);
    });
  }

  // =============================================================================
  // 外部リンク自動 target="_blank" 化
  // =============================================================================
  function initExternalLinks() {
    var currentHost = window.location.hostname;
    var links = document.querySelectorAll('a[href]');

    links.forEach(function (link) {
      var href = link.getAttribute('href');

      if (link.hasAttribute('target')) {
        return;
      }

      if (link.hasAttribute('data-no-external')) {
        return;
      }

      if (href && (href.indexOf('http://') === 0 || href.indexOf('https://') === 0)) {
        if (href.indexOf(currentHost) === -1) {
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'noopener noreferrer');
        }
      }
    });
  }

  // =============================================================================
  // ページ読み込み完了後のフェードイン表示
  // =============================================================================
  function initPageLoadReveal() {
    var html = document.documentElement;

    function reveal() {
      html.classList.add('is-page-loaded');
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      reveal();
      return;
    }

    var domReady = document.readyState === 'loading'
      ? new Promise(function (resolve) {
        document.addEventListener('DOMContentLoaded', resolve, { once: true });
      })
      : Promise.resolve();

    var fontsReady = document.fonts && document.fonts.ready
      ? document.fonts.ready
      : Promise.resolve();

    var fallbackTimer = setTimeout(reveal, 4000);

    Promise.all([domReady, fontsReady]).then(function () {
      clearTimeout(fallbackTimer);
      reveal();
    });
  }

  function initLenis() {
    if (typeof Lenis === 'undefined') {
      return;
    }

    var hasGsap = typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined';

    if (hasGsap) {
      gsap.registerPlugin(ScrollTrigger);
    }

    lenis = new Lenis({
      autoRaf: !hasGsap,
      autoToggle: true,
      anchors: true,
      allowNestedScroll: true,
      naiveDimensions: true,
      stopInertiaOnNavigate: true,
    });

    if (hasGsap) {
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(function (time) {
        lenis.raf(time * 1000);
      });
      gsap.ticker.lagSmoothing(0);
    }

    window.MedicomCustom.lenis = lenis;
  }

  function init() {
    initPageLoadReveal();
    initLenis();
    initHeaderMenu();
    initHeroSplide();
    initOriginalBrandSplide();
    initRecruitWelfareSplide();
    initRecruitGallerySplide();
    initAccordion();
    initRecruitJobGallery();
    initOriginalBrandModal();
    initOriginalBrandGridModal();
    initCollaboratorSplide();
    initScrollTrigger();
    initCompanyHistory();
    initParallax();
    initBlogPagination();
    initArticleShare();
    initExternalLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // =============================================================================
  // Shopify テーマカスタマイザー対応
  // =============================================================================
  document.addEventListener('shopify:section:load', function () {
    initHeaderMenu();
    initHeroSplide();
    initOriginalBrandSplide();
    initRecruitWelfareSplide();
    initRecruitGallerySplide();
    initAccordion();
    initRecruitJobGallery();
    initOriginalBrandModal();
    initOriginalBrandGridModal();
    initCollaboratorSplide();
    initScrollTrigger();
    initCompanyHistory();
    initParallax();
    initBlogPagination();
    initArticleShare();
    initExternalLinks();
    // initLenis / initPageLoadReveal は再実行しない（シングルトン・1回限り）
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target;

    // Splide インスタンスの破棄
    var splideContainers = section.querySelectorAll(
      '.s-hero__splide, .s-original-brand__splide, .s-recruit-welfare__splide, .s-recruit-gallery__splide, .s-collaborator__splide, .s-original-brand__modal-gallery, .s-original-brand-grid__modal-gallery, [data-recruit-job-gallery]'
    );
    splideContainers.forEach(function (container) {
      if (container._splideInstance) {
        container._splideInstance.destroy();
        container._splideInstance = null;
      }
      if (container._marqueeAnimation) {
        container._marqueeAnimation.cancel();
        container._marqueeAnimation = null;
      }
      if (container._collaboratorMarqueeResizeObserver) {
        container._collaboratorMarqueeResizeObserver.disconnect();
        container._collaboratorMarqueeResizeObserver = null;
      }
      if (container._collaboratorResizeObserver) {
        container._collaboratorResizeObserver.disconnect();
        container._collaboratorResizeObserver = null;
      }
      if (container._modalGalleryMarqueeResizeObserver) {
        container._modalGalleryMarqueeResizeObserver.disconnect();
        container._modalGalleryMarqueeResizeObserver = null;
      }
      if (container._modalGalleryResizeObserver) {
        container._modalGalleryResizeObserver.disconnect();
        container._modalGalleryResizeObserver = null;
      }
      container._modalGalleryUseLoop = false;
    });

    // GSAP ScrollTrigger（CompanyHistory 等）のクリーンアップ
    if (typeof ScrollTrigger !== 'undefined') {
      ScrollTrigger.getAll().forEach(function (st) {
        if (st.trigger && section.contains(st.trigger)) {
          st.kill();
        }
      });
    }
  });

  window.MedicomCustom.lockScroll = lockScroll;
  window.MedicomCustom.unlockScroll = unlockScroll;
})();
